import React from "react";
import { Card, CardContent, Typography, Box, Stack } from "@mui/material";
import { ComputerDesktopIcon, UserIcon } from "@heroicons/react/24/outline";
import styles from "../../styles/launchDetails/testLaunchPrimaryCard.module.scss"; 

const THEMES = {
  automated: {
    cardBg: "#EFF6FF", // blue-50
    border: "#BFDBFE", // blue-200
    icon: "#2563EB", // blue-600
    title: "#1E3A8A", // blue-900
    subtitle: "#1D4ED8", // blue-700
    passRate: "#2563EB", // blue-600
    ImageIcon: ComputerDesktopIcon,
  },
  manual: {
    cardBg: "#ECFDF5", // green-50
    border: "#BBF7D0", // green-200
    icon: "#16A34A", // green-600
    title: "#14532D", // green-900
    subtitle: "#15803D", // green-700
    passRate: "#16A34A", // green-600
    ImageIcon: UserIcon,
  },
};

const TestLaunchPrimaryCard = ({ primaryLabel,secondaryLabel,percentage, type = "automated" }) => {
  const theme = THEMES[type] || THEMES.automated; 

  return (
    <Card
      sx={{
        bgcolor: theme.cardBg,
        borderRadius: 2,
        border: "1px solid",
        borderColor: theme.border,
        p: 2,
      }}
    >
      <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <theme.ImageIcon
            style={{ height: 30, width: 30, color: theme.icon }}
          />

          <Box flex={1}>
            <Typography
              className={styles['primary-card-title']}
              sx={{ color: theme.title }}
            >
                {primaryLabel}
            </Typography>
            <Typography 
              className={styles['primary-card-subtitle']}
              sx={{ color: theme.subtitle }}
            >
              {secondaryLabel}
            </Typography>
          </Box>

          <Box textAlign="right">
            <Typography

              className={styles['primary-card-percentage']}
              sx={{ color: theme.title }}
            >
              {percentage}%
            </Typography>
            <Typography 
              
              className={styles['primary-card-pass-rate']}
              sx={{ color: theme.passRate }}
            >
              Pass Rate
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TestLaunchPrimaryCard;
